/* eslint-disable */
import { mapGetters, mapState, mapActions } from 'vuex';
import disqus from '@/components/disqus/disqus.vue';
import marketPayoutSushi from '@/components/market/market-payout-sushi/market-payout-sushi.vue';
import alertBox from '@/components/generics/alert-box/alert-box.vue';
import tabs from '@/components/generics/tabs/tabs.vue';
import accountVerifyMixin from '@/mixins/accountVerify';
import headerTagsMixin from '@/mixins/headerTags';
import headerHeightMixin from '@/mixins/headerHeight';
import { isMarketSettled, isMarketDisabled, isMarketSingle, hasMarketHiddenContracts, hasMarketPayout, marketUserGainLoss, roundToTwo } from '@/utils/helpers';
import { MODALS } from '@/components/app/app-modals/app-modals';
import { waitForStatusReady } from '@/utils/mutex';
import sushiMarketDiscussionWidget from "./components/sushi-market-discussion-widget/sushi-market-discussion-widget.vue";
import sushiMarketLinksWidget from "./components/sushi-market-links-widget/sushi-market-links-widget.vue";
import marketWatch from '@/components/market/market-watch/market-watch.vue';
import constants from '@/constants';
import { BRAND } from '@/components/brand-name/brand-name.js';
import pageSushiMarketCharts from '@/components/pages/page-market-detail-sushi/pages/sushi-market-charts/sushi-market-charts.vue';
import pageSushiMarketDiscussion from '@/components/pages/page-market-detail-sushi/pages/sushi-market-discussion/sushi-market-discussion.vue';
import pageSushiMarketHistory from '@/components/pages/page-market-detail-sushi/pages/sushi-market-history/sushi-market-history.vue';
import pageSushiMarketRules from '@/components/pages/page-market-detail-sushi/pages/sushi-market-rules/sushi-market-rules.vue';
import pageSushiMarketContracts from '@/components/pages/page-market-detail-sushi/pages/sushi-market-contracts/sushi-market-contracts.vue';
import pageSushiMarketLinks from '@/components/pages/page-market-detail-sushi/pages/sushi-market-links/sushi-market-links.vue';
import pageSushiMarketResearch from '@/components/pages/page-market-detail-sushi/pages/sushi-market-research/sushi-market-research.vue';
import pageSushiMarketMethodology from '@/components/pages/page-market-detail-sushi/pages/sushi-market-methodology/sushi-market-methodology.vue';
import marketAlertV2 from '@/components/market/v2/market-alert-v2/market-alert-v2.vue';
import marketSiteAlertV2 from '@/components/market/v2/market-site-alert-v2/market-site-alert-v2.vue';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import marketCharts from '@/components/market/market-detail-charts/market-detail-charts.vue';
import scrollTo from '@/utils/scrollTo'
import Contract from '@/models/contract';
import { parseQuery } from '@/utils/helpers';
import {
  VALUES, OPERATIONS,
} from '@/components/market/market-contract-horizontal-sushi/market-contract-horizontal-sushi'
import purchaseOfferSushiMobileBar from '@/components/purchase/sushi/purchase-offer-sushi-mobile-bar/purchase-offer-sushi-mobile-bar.vue';
import { BOTTOM_WIDGET_FOOTER_MODES } from '@/store/modules/trade';
import log from '@/logger';
import store from '@/store';

const DEFAULT_PAGE_TITLE = BRAND;

export const NAVIGATION_TABS = {
  CONTRACTS: 'contracts',
  RESEARCH: 'research',
  METHODOLOGY: 'methodology',
  RULES: 'rules',
  CHARTS: 'charts',
  HISTORY: 'history',
  DISCUSSION: 'discussion',
  LINKS: 'links'
};

const ROUTE_DRIVEN_TABS = [
  NAVIGATION_TABS.CONTRACTS,
  NAVIGATION_TABS.RESEARCH,
  NAVIGATION_TABS.METHODOLOGY,
  NAVIGATION_TABS.RULES,
  NAVIGATION_TABS.CHARTS,
  NAVIGATION_TABS.HISTORY,
  NAVIGATION_TABS.DISCUSSION,
  NAVIGATION_TABS.LINKS,
];

const AUTH_REQUIRING_TABS = [
  NAVIGATION_TABS.HISTORY,
  NAVIGATION_TABS.LINKS,
]

function resolveActiveTab(tab) {
  if (!ROUTE_DRIVEN_TABS.includes(tab)) {
    return  NAVIGATION_TABS.CONTRACTS;
  }
  if (AUTH_REQUIRING_TABS.includes(tab) && !store.getters['user/isLoggedIn']) {
    return NAVIGATION_TABS.CONTRACTS;
  }
  return ROUTE_DRIVEN_TABS.includes(tab) ? tab : NAVIGATION_TABS.CONTRACTS;
}

function buildDiscussionQuery(query, commentId = '', commentThreadId = 0) {
  const nextQuery = {
    ...query,
    tab: NAVIGATION_TABS.DISCUSSION,
  };

  if (Number(commentThreadId) > 0) {
    nextQuery.commentThreadId = Number(commentThreadId);
  } else {
    delete nextQuery.commentThreadId;
  }

  if (commentId) {
    nextQuery.commentId = commentId;
  } else {
    delete nextQuery.commentId;
  }

  return nextQuery;
}

function buildTabQuery(query, tab) {
  const nextQuery = {
    ...query,
  };

  delete nextQuery.commentThreadId;
  delete nextQuery.commentId;

  if (tab && tab !== NAVIGATION_TABS.CONTRACTS) {
    nextQuery.tab = tab;
  } else {
    delete nextQuery.tab;
  }

  return nextQuery;
}

function buildCommentHash(commentId = '') {
  return commentId ? `#comment-${commentId}` : '';
}

function normalizeCommentThreadId(commentThreadId) {
  const normalized = Number(commentThreadId);

  return Number.isFinite(normalized) && normalized > 0 ? normalized : 0;
}

function resolveRouteMarketId(route) {
  return Number(route && route.params ? route.params.marketId : 0);
}

function resolveDiscussionCommentId(route) {
  if (route && route.query && route.query.commentId) {
    return route.query.commentId;
  }

  if (route && route.hash && route.hash.indexOf('#comment-') === 0) {
    return route.hash.replace('#comment-', '');
  }

  return '';
}

function getCurrentLocationQuery() {
  const query = parseQuery(window.location.search || '');

  delete query[''];

  return query;
}

export default {
  mixins: [
    accountVerifyMixin,
    headerTagsMixin,
    headerHeightMixin,
    loaderMixin,
    contentLoaderMixin,
  ],
  components: {
    alertBox,
    disqus,
    tabs,
    sushiMarketDiscussionWidget,
    sushiMarketLinksWidget,
    marketPayoutSushi,
    marketWatch,
    pageSushiMarketCharts,
    pageSushiMarketDiscussion,
    pageSushiMarketHistory,
    pageSushiMarketRules,
    pageSushiMarketContracts,
    pageSushiMarketLinks,
    pageSushiMarketResearch,
    pageSushiMarketMethodology,
    marketAlertV2,
    marketSiteAlertV2,
    marketCharts,
    purchaseOfferSushiMobileBar,
  },
  props: {
    showRules: {
      type: Boolean,
      default: false,
    },
    marketId: {
      type: Number,
      required: true,
    },
    prerendered: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      NAVIGATION_TABS,
      titleHovered: false,
      stickyObserver: null,
      onScroll: null,
      stickyScrollAnimationFrame: null,
      contentResizeObserver: null,
      desktopStickyTitleHeight: 0,
      desktopContentMinHeight: 0,
      mobileContentMinHeight: 0,
      mobileContentHeightReleaseTimer: null,
      mobileContentHeightReleaseAnimationFrame: null,
      discussionWidgetRouteSwap: 1,
      isResetting: false,
      showAllContracts: false,
      activeTab: resolveActiveTab(this.$route.query.tab),
      requestedDiscussionCommentId: resolveDiscussionCommentId(this.$route),
      requestedDiscussionCommentThreadId: normalizeCommentThreadId(this.$route.query.commentThreadId),
      showHistory: false,
      toolbarTabsCanScrollLeft: false,
      toolbarTabsCanScrollRight: false,
      toolbarTabsResizeObserver: null,
      hideMainChart: false,
      isTitleSticky: false,
      initialised: false,
      reloading: false,
      tabScrollPositions: {},
    };
  },
  metaInfo() {
    if (this.market && this.market.marketId) {
      return {
        title: this.market.seoTitle,
        link: [
          { rel: 'canonical', href: `${window.location.href}` },
        ],
        meta: [
          { name: 'description', content: this.market.seoDescription },
          { itemprop: 'name', content: this.market.seoTitle },
          { itemprop: 'description', content: this.market.seoDescription },
          { itemprop: 'image', content: this.market.imageName },
          { property: 'og:title', content: this.market.seoTitle },
          { property: 'og:type', content: 'article' },
          { property: 'og:image', content: this.market.imageName },
          { property: 'og:description', content: this.market.seoDescription },
          { property: 'og:site_name', content: BRAND },
          { property: 'og:url', content: `${window.location.href}` },
        ],
      };
    }
    return {};
  },
  computed: {
    ...mapGetters('user', ['isLoggedIn']),
    ...mapGetters('app', [
      'isLayoutDesktop', 'isLayoutMobile', 'isCommentEnabled',
      'isAfterHours', 'isRegularMaintenance', 'isExtendedMaintenance',
      'isPinningEnabled',
    ]),
    ...mapState('app', ['previousRoute', 'settingShowOdds']),
    ...mapState('market', [
      'market', 'contracts', 'marketLoadError',
      'marketIsEngineBusy', 'marketIsEngineBusyMessage',
      'isDiscussionPinned',
    ]),
    ...mapState('trade', [
      'tradeOptions',
      'bottomBetslipExtended',
      'bottomWidgetFooterMode',
      'bottomWidgetFooterModeContractsSection',
      'hasStoredBottomWidgetFooterModePreference',
    ]),
    ...mapState('popup', ['currentPopup']),
    ...mapState('notifications', ['lastConfirmedContractData']),
    ...mapState('user', ['status']),
    isShortcutWidgetVisible() {
      return this.market !== null && !!this.market.marketId && !this.isMarketDisabled && this.initialised && !this.isResetting && this.isLayoutMobile && this.activeTab !== NAVIGATION_TABS.CONTRACTS;
    },
    displayedMarketName() {
      if (!this.market) {
        return '';
      }

      return this.isTitleSticky
        ? this.pinnedMarketName
        : this.market.marketName;
    },
    pinnedMarketName() {
      if (!this.market) {
        return '';
      }

      return this.market.marketShortName || this.market.marketName;
    },
    desktopStickyTitleOffset() {
      if (!this.isLayoutDesktop || !this.isTitleSticky) {
        return 0;
      }

      // Desktop stacks the sticky short title above the tabs, so the toolbar
      // always needs the final rendered title height and not just the header.
      if (this.desktopStickyTitleHeight > 0) {
        return this.desktopStickyTitleHeight;
      }

      const $stickyTitle = document.querySelector('.page-market-detail-sushi__title--is-sticky');

      return $stickyTitle ? $stickyTitle.offsetHeight : 0;
    },
    toolbarStyleModifiers() {
      return {
        top: `${this.headerHeight + this.desktopStickyTitleOffset}px`,
      };
    },
    contentStyleModifiers() {
      const contentMinHeight = this.isLayoutDesktop ?
        this.desktopContentMinHeight :
        this.mobileContentMinHeight;

      if (!contentMinHeight) {
        return {};
      }

      return {
        minHeight: `${contentMinHeight}px`,
      };
    },
    titleStyleModifiers() {
      if (this.isLayoutMobile && !this.isMarketDisabled) {
        return {
          top: `${this.headerHeight}px`,
        };
      }

      if (!this.isTitleSticky) {
        return {};
      }
      return {
        top: `${this.headerHeight}px`,
      };
    },
    showStickyTitleSummary() {
      return this.isTitleSticky && this.isPayoutAvailable;
    },
    isExpandedMobileBetslipActive() {
      return this.isLayoutMobile &&
        this.bottomWidgetFooterMode === BOTTOM_WIDGET_FOOTER_MODES.BETSLIP &&
        this.bottomBetslipExtended;
    },
    stickyUserGainLoss() {
      if (!this.market) {
        return 0;
      }

      return marketUserGainLoss(this.market);
    },
    stickyUserGainLossNormalized() {
      return roundToTwo(this.stickyUserGainLoss) === 0 ? 0 : this.stickyUserGainLoss;
    },
    stickyUserGainLossLabel() {
      if (this.stickyUserGainLossNormalized > 0) {
        return 'Gain';
      }

      return this.stickyUserGainLossNormalized < 0 ? 'Loss' : 'Gain/Loss';
    },
    showDesktopTitlePayout() {
      return this.isPayoutAvailable && this.isLayoutDesktop && !this.isTitleSticky;
    },
    showDesktopTitleWatch() {
      return this.isLayoutDesktop && this.watchIconVisible;
    },
    showMobileTitleWatch() {
      return this.isLayoutMobile && this.watchIconVisible;
    },
    newMarketBarDescription() {
      return this.isLayoutDesktop ?
        'Orderbooks and features may be limited.' :
        'Features may be limited.';
    },
    watchIconVisible() {
      const statuses = [
        constants.MARKET_EXPIRED,
        constants.MARKET_SETTLED,
      ];
      return this.isLoggedIn && !statuses.includes(this.market.status);
    },
    discussionWidgetKey() {
      return `market--${this.discussionWidgetRouteSwap.toString()}`;
    },
    navigationTabs () {
      let results = [
        {
          name: NAVIGATION_TABS.CONTRACTS,
          title: 'Contracts',
        },
      ];

      // results = [
      //   ...results,
      //   {
      //     name: NAVIGATION_TABS.CHARTS,
      //     title: 'Charts',
      //   },
      // ]

      results = [
        ...results,
        {
          name: NAVIGATION_TABS.DISCUSSION,
          title: 'Discussion',
        },
        {
          name: NAVIGATION_TABS.RULES,
          title: 'Rules',
          meta: {
            numRuleComments: this.market ? this.market.numRuleComments : 0,
          },
        },
      ];

      if (this.isLoggedIn) {
        results = [
          ...results,
          {
            name: NAVIGATION_TABS.HISTORY,
            title: 'History',
          },
          {
            name: NAVIGATION_TABS.LINKS,
            title: 'Lists',
          },
        ]
      }


      return results;
    },
    isMarketDisabled() {
      return isMarketDisabled(this.market);
    },
    isMarketSettled() {
      return isMarketSettled(this.market);
    },
    isPayoutAvailable() {
      return this.isLoggedIn && hasMarketPayout(this.market) && !this.isMarketSettled;
    },
    isAllPayoutsAvailable() {
      return !isMarketSingle(this.market);
    },
    title() {
      return `Market details for ${this.market.symbol}--${this.market.marketId}`;
    },
    showEngineBusyNotification() {
      return (
        (this.market.isEngineBusy && this.market.isEngineBusyMessage) ||
        (this.marketIsEngineBusy && this.marketIsEngineBusyMessage)
      );
    },
    engineBusyNotificationContent() {
      return this.market.isEngineBusyMessage || this.marketIsEngineBusyMessage;
    },
    ogImageSrc() {
      return this.prerendered !== '' && this.market && this.market.imageName;
    },
    showEconomicIndicator() {
      return [2, 3, 4].includes(this.market.econIndicatorTradeStatus);
    },
    showDiscussionWidget() {
      return this.isPinningEnabled && this.isLoggedIn && this.isDiscussionPinned && this.isCommentEnabled;
    },
    showMarketLinksWidget() {
      return this.isPinningEnabled && this.isLoggedIn;
    },
  },
  methods: {
    ...mapActions('insight', ['getMarketFeeds']),
    ...mapActions('market', [
      'getMarket', 'clearMarket', 'clearMarketEngineBusyMessage', 'getMarketContractsStats',
    ]),
    ...mapActions('popup', ['setCurrentPopup', 'setTradePopup', 'setGenericPopup']),
    ...mapActions('trade', [
      'setTradeOptions', 'setTradePrice', 'setTradeQuantity', 'clearOrderBook',
      'setBottomBetSlipExtendedMode', 'toggleHidePurchaseForContractId',
      'setBottomWidgetFooterMode', 'setBottomWidgetFooterModeContractsSection',
    ]),
    isMarketDetailPath(path = '') {
      return typeof path === 'string' && path.indexOf('/markets/detail/') === 0;
    },
    shouldPreserveMobileFooterMode(fromRoute = null) {
      if (fromRoute && fromRoute.name === 'market-details') {
        return true;
      }

      return this.isMarketDetailPath(this.previousRoute);
    },
    applyDefaultMobileFooterMode({ fromRoute = null } = {}) {
      if (!this.isLayoutMobile) {
        return;
      }

      this.setBottomBetSlipExtendedMode(false);

      if (!this.hasStoredBottomWidgetFooterModePreference &&
        !this.shouldPreserveMobileFooterMode(fromRoute)) {
        this.setBottomWidgetFooterModeContractsSection(BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH);
      }

      if (this.activeTab === NAVIGATION_TABS.CONTRACTS) {
        this.setBottomWidgetFooterMode(this.bottomWidgetFooterModeContractsSection);
        return;
      }

      this.setBottomWidgetFooterMode(BOTTOM_WIDGET_FOOTER_MODES.QUICK_SWITCH);
    },
    destroyStickyTracking() {
      if (this.stickyObserver) {
        this.stickyObserver.disconnect();
        this.stickyObserver = null;
      }

      if (this.onScroll) {
        window.removeEventListener('scroll', this.onScroll);
        this.onScroll = null;
      }

      if (this.stickyScrollAnimationFrame && window.cancelAnimationFrame) {
        window.cancelAnimationFrame(this.stickyScrollAnimationFrame);
        this.stickyScrollAnimationFrame = null;
      }

      this.desktopStickyTitleHeight = 0;
    },
    destroyDesktopContentHeightTracking({ resetHeight = false } = {}) {
      if (this.contentResizeObserver) {
        this.contentResizeObserver.disconnect();
        this.contentResizeObserver = null;
      }

      if (resetHeight) {
        this.desktopContentMinHeight = 0;
      }
    },
    cancelMobileContentHeightRelease() {
      if (this.mobileContentHeightReleaseTimer) {
        window.clearTimeout(this.mobileContentHeightReleaseTimer);
        this.mobileContentHeightReleaseTimer = null;
      }

      if (this.mobileContentHeightReleaseAnimationFrame) {
        window.cancelAnimationFrame(this.mobileContentHeightReleaseAnimationFrame);
        this.mobileContentHeightReleaseAnimationFrame = null;
      }
    },
    destroyMobileContentHeightLock({ resetHeight = false } = {}) {
      this.cancelMobileContentHeightRelease();

      if (resetHeight) {
        this.mobileContentMinHeight = 0;
      }
    },
    getToolbarTabsScroller() {
      if (!this.$refs.toolbarTabs) {
        return null;
      }

      return this.$refs.toolbarTabs.querySelector('.tabs');
    },
    initToolbarTabsScrollTracking() {
      this.destroyToolbarTabsScrollTracking();
      this.$nextTick(() => {
        const $tabs = this.getToolbarTabsScroller();

        if (!$tabs) {
          this.refreshToolbarTabsScrollState();
          return;
        }

        $tabs.addEventListener('scroll', this.refreshToolbarTabsScrollState, { passive: true });

        if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
          this.toolbarTabsResizeObserver = new ResizeObserver(this.refreshToolbarTabsScrollState);
          this.toolbarTabsResizeObserver.observe($tabs);
        }

        this.refreshToolbarTabsScrollState();
        this.scheduleToolbarTabIntoView(this.activeTab);
      });
    },
    destroyToolbarTabsScrollTracking() {
      const $tabs = this.getToolbarTabsScroller();

      if ($tabs) {
        $tabs.removeEventListener('scroll', this.refreshToolbarTabsScrollState);
      }

      if (this.toolbarTabsResizeObserver) {
        this.toolbarTabsResizeObserver.disconnect();
        this.toolbarTabsResizeObserver = null;
      }
    },
    refreshToolbarTabsScrollState() {
      const $tabs = this.getToolbarTabsScroller();

      if (!this.isLayoutMobile || !$tabs) {
        this.toolbarTabsCanScrollLeft = false;
        this.toolbarTabsCanScrollRight = false;
        return;
      }

      const maxScrollLeft = Math.max(0, $tabs.scrollWidth - $tabs.clientWidth);
      const $firstTab = $tabs.querySelector('.tabs__item:first-child');
      const $lastTab = $tabs.querySelector('.tabs__item:last-of-type');
      const tabsRect = $tabs.getBoundingClientRect();
      const firstTabRect = $firstTab ? $firstTab.getBoundingClientRect() : null;
      const lastTabRect = $lastTab ? $lastTab.getBoundingClientRect() : null;

      this.toolbarTabsCanScrollLeft = maxScrollLeft > 1 && firstTabRect && firstTabRect.left < tabsRect.left - 1;
      this.toolbarTabsCanScrollRight = maxScrollLeft > 1 && lastTabRect && lastTabRect.right > tabsRect.right + 1;
    },
    scrollToolbarTabs(direction) {
      const $tabs = this.getToolbarTabsScroller();

      if (!$tabs) {
        return;
      }

      const distance = Math.max(120, Math.floor($tabs.clientWidth * 0.8));
      const left = $tabs.scrollLeft + (distance * direction);

      if (typeof $tabs.scrollTo === 'function') {
        $tabs.scrollTo({ left, behavior: 'smooth' });
      } else {
        $tabs.scrollLeft = left;
      }

      window.setTimeout(this.refreshToolbarTabsScrollState, 250);
    },
    scheduleToolbarTabIntoView(tabName = this.activeTab) {
      if (!this.isLayoutMobile || !tabName) {
        return;
      }

      this.$nextTick(() => {
        this.scrollToolbarTabIntoView(tabName);

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(() => {
            this.scrollToolbarTabIntoView(tabName);
          });
        }

        window.setTimeout(() => {
          this.scrollToolbarTabIntoView(tabName);
        }, 150);
      });
    },
    scrollToolbarTabIntoView(tabName) {
      if (!this.isLayoutMobile || !tabName) {
        return;
      }

      const $tabs = this.getToolbarTabsScroller();

      if (!$tabs) {
        return;
      }

      const $tab = $tabs.querySelector(`.tabs__link-name-${tabName}`);

      if (!$tab) {
        return;
      }

      const tabsRect = $tabs.getBoundingClientRect();
      const tabRect = $tab.getBoundingClientRect();
      const maxScrollLeft = Math.max(0, $tabs.scrollWidth - $tabs.clientWidth);
      const scrollButtonWidth = 28;
      const scrollButtonBuffer = 8;
      const overlaySafeWidth = scrollButtonWidth + scrollButtonBuffer;
      const visibleLeft = tabsRect.left + ($tabs.scrollLeft > 1 ? overlaySafeWidth : 0);
      const visibleRight = tabsRect.right - ($tabs.scrollLeft < maxScrollLeft - 1 ? overlaySafeWidth : 0);
      const leftOverflow = tabRect.left - visibleLeft;
      const rightOverflow = tabRect.right - visibleRight;
      let nextScrollLeft = $tabs.scrollLeft;

      if (leftOverflow < 0) {
        nextScrollLeft += leftOverflow;
      } else if (rightOverflow > 0) {
        nextScrollLeft += rightOverflow;
      } else {
        this.refreshToolbarTabsScrollState();
        return;
      }

      nextScrollLeft = Math.max(0, Math.min(nextScrollLeft, maxScrollLeft));

      if (typeof $tabs.scrollTo === 'function') {
        $tabs.scrollTo({ left: nextScrollLeft, behavior: 'smooth' });
      } else {
        $tabs.scrollLeft = nextScrollLeft;
      }

      window.setTimeout(this.refreshToolbarTabsScrollState, 250);
    },
    captureDesktopContentHeight() {
      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      this.desktopContentMinHeight = this.$refs.marketContent.offsetHeight;
    },
    captureMobileContentHeight() {
      if (!this.isLayoutMobile || !this.$refs.marketContent) {
        return;
      }

      this.cancelMobileContentHeightRelease();

      const currentHeight = this.$refs.marketContent.offsetHeight;
      const minHeightToPreventClamp = this.resolveContentMinHeight();

      this.mobileContentMinHeight = Math.ceil(Math.max(currentHeight, minHeightToPreventClamp));
    },
    getNaturalContentHeight() {
      if (!this.$refs.marketContent || !this.$refs.marketContentInner) {
        return 0;
      }

      const styles = window.getComputedStyle(this.$refs.marketContent);
      const verticalChrome =
        parseFloat(styles.paddingTop || 0) +
        parseFloat(styles.paddingBottom || 0) +
        parseFloat(styles.borderTopWidth || 0) +
        parseFloat(styles.borderBottomWidth || 0);

      return Math.ceil(this.$refs.marketContentInner.offsetHeight + verticalChrome);
    },
    resolveContentMinHeight() {
      if (!this.$refs.marketContent) {
        return 0;
      }

      const naturalHeight = this.getNaturalContentHeight();
      const scrollTop = window.pageYOffset || window.scrollY || 0;
      const contentTop = this.$refs.marketContent.getBoundingClientRect().top + scrollTop;
      const currentHeight = this.$refs.marketContent.offsetHeight;
      const documentHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body ? document.body.scrollHeight : 0
      );
      const chromeBelowContent = Math.max(0, documentHeight - contentTop - currentHeight);
      const viewportBottom = scrollTop + window.innerHeight;
      // The page shell needs this temporary min-height so tab swaps do not clamp the document
      // while the next panel is mounting and the scroll position is being restored.
      const minHeightToPreventClamp = Math.max(0, viewportBottom - contentTop - chromeBelowContent);

      return Math.ceil(Math.max(naturalHeight, minHeightToPreventClamp));
    },
    syncDesktopContentMinHeight() {
      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      const nextHeight = this.resolveContentMinHeight();

      if (nextHeight > 0 && nextHeight !== this.desktopContentMinHeight) {
        this.desktopContentMinHeight = nextHeight;
      }
    },
    refreshDesktopContentHeightTracking() {
      if (this.isResetting) {
        return;
      }

      this.$nextTick(() => {
        if (!this.isLayoutDesktop || !this.$refs.marketContent || !this.$refs.marketContentInner) {
          this.destroyDesktopContentHeightTracking({ resetHeight: true });
          return;
        }

        this.syncDesktopContentMinHeight();

        if (typeof window !== 'undefined' && 'ResizeObserver' in window) {
          this.destroyDesktopContentHeightTracking();
          this.contentResizeObserver = new ResizeObserver(() => {
            this.syncDesktopContentMinHeight();
          });
          this.contentResizeObserver.observe(this.$refs.marketContentInner);
        }

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(() => {
            this.syncDesktopContentMinHeight();
          });
        }
      });
    },
    isDesktopToolbarPinned() {
      if (!this.isLayoutDesktop) {
        return false;
      }

      const $toolbar = this.$el ? this.$el.querySelector('.page-market-detail-sushi__toolbar') : null;
      if (!$toolbar) {
        return false;
      }

      const stickyTop = this.headerHeight + this.desktopStickyTitleOffset;
      const toolbarTop = $toolbar.getBoundingClientRect().top;

      return toolbarTop <= stickyTop + 1;
    },
    resetDesktopTabContentScroll() {
      if (!this.isLayoutDesktop || !this.$refs.marketContent) {
        return;
      }

      const $toolbar = this.$el ? this.$el.querySelector('.page-market-detail-sushi__toolbar') : null;
      if (!$toolbar) {
        return;
      }

      const toolbarBottom = $toolbar.getBoundingClientRect().bottom;
      const scrollTop = window.pageYOffset || window.scrollY || 0;
      const contentTop = this.$refs.marketContent.getBoundingClientRect().top + scrollTop;
      const nextScrollTop = Math.max(0, Math.ceil(contentTop - toolbarBottom));

      // Once the desktop tabs are pinned, reset the new tab back to its own top instead of inheriting a deep scroll from the last tab.
      window.scrollTo(0, nextScrollTop);

      if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
        window.requestAnimationFrame(() => {
          this.syncDesktopContentMinHeight();
        });
        return;
      }

      this.syncDesktopContentMinHeight();
    },
    isMobileToolbarVisible() {
      if (!this.isLayoutMobile || !this.$el) {
        return false;
      }

      const $toolbar = this.$el.querySelector('.page-market-detail-sushi__toolbar');
      if (!$toolbar) {
        return false;
      }

      const toolbarRect = $toolbar.getBoundingClientRect();

      return toolbarRect.bottom > this.headerHeight && toolbarRect.top < window.innerHeight;
    },
    scheduleMobileContentHeightRelease({ delay = 0 } = {}) {
      const release = () => {
        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          this.mobileContentHeightReleaseAnimationFrame = window.requestAnimationFrame(() => {
            this.mobileContentHeightReleaseAnimationFrame = window.requestAnimationFrame(() => {
              this.mobileContentHeightReleaseAnimationFrame = null;
              this.mobileContentMinHeight = 0;
            });
          });
          return;
        }

        this.mobileContentMinHeight = 0;
      };

      this.cancelMobileContentHeightRelease();

      if (delay > 0) {
        this.mobileContentHeightReleaseTimer = window.setTimeout(() => {
          this.mobileContentHeightReleaseTimer = null;
          release();
        }, delay);
        return;
      }

      release();
    },
    restoreMobileTabContentScroll(tab, { preserveToolbarPosition = false } = {}) {
      if (!this.isLayoutMobile || !this.$refs.marketContent) {
        this.destroyMobileContentHeightLock({ resetHeight: true });
        return;
      }

      if (preserveToolbarPosition) {
        this.scheduleMobileContentHeightRelease({ delay: 400 });
        return;
      }

      let topOffset = this.headerHeight;

      if (this.$refs.marketTitle) {
        topOffset += this.$refs.marketTitle.offsetHeight;
      }

      if (this.tabScrollPositions[tab] !== undefined) {
        log.info(`Scrolling to last position for ${tab}`);
        window.scrollTo(0, this.tabScrollPositions[tab]);
        this.scheduleMobileContentHeightRelease();
        return;
      }

      this.scheduleMobileContentHeightRelease({ delay: 400 });
      scrollTo(this.$refs.marketContent, 250, 'linear', null, topOffset, () => {
        this.scheduleMobileContentHeightRelease();
      });
    },
    syncDesktopStickyTitleHeight() {
      if (!this.isLayoutDesktop || !this.isTitleSticky || !this.$refs.marketTitle) {
        this.desktopStickyTitleHeight = 0;
        return;
      }

      this.desktopStickyTitleHeight = this.$refs.marketTitle.offsetHeight;
    },
    getPageScrollTop() {
      let scrollTop = window.pageYOffset ||
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;

      if (this.isLayoutMobile &&
        this.bottomBetslipExtended &&
        document.body.style.position === 'fixed' &&
        document.body.style.top) {
        const lockedScrollTop = parseInt(document.body.style.top, 10);

        if (!Number.isNaN(lockedScrollTop)) {
          scrollTop = Math.abs(lockedScrollTop);
        }
      }

      return scrollTop;
    },
    isAtPageTop() {
      const scrollTop = this.getPageScrollTop();

      return scrollTop <= 1;
    },
    scheduleStickyTitleStateUpdate() {
      this.$nextTick(() => {
        const update = () => {
          this.updateTitleStickyState();
        };

        if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(update);
          return;
        }

        update();
      });
    },
    updateTitleStickyState(stickySentinelTop = null) {
      if (this.isLayoutMobile && this.isAtPageTop()) {
        this.isTitleSticky = false;
        return;
      }

      if (stickySentinelTop === null) {
        if (!this.$refs.stickySentinel) {
          this.isTitleSticky = false;
          return;
        }

        stickySentinelTop = this.$refs.stickySentinel.getBoundingClientRect().top;
      }

      this.isTitleSticky = !this.isMarketDisabled && stickySentinelTop <= this.headerHeight;
    },
    refreshStickyObserver() {
      if (this.isResetting) {
        return;
      }

      this.$nextTick(() => {
        this.initStickyObserver();
      });
    },
    initStickyObserver() {
      this.destroyStickyTracking();

      if (!this.$refs.stickySentinel) {
        this.isTitleSticky = false;
        return;
      }

      const useScrollFallback = this.isLayoutMobile || !('IntersectionObserver' in window);
      if (useScrollFallback) {
        this.initScrollFallback();
      }

      if (!('IntersectionObserver' in window)) {
        this.updateTitleStickyState();
        return;
      }

      this.stickyObserver = new IntersectionObserver(
        ([entry]) => {
          this.updateTitleStickyState(entry.boundingClientRect.top);
        },
        {
          rootMargin: `-${this.headerHeight}px 0px 0px 0px`,
          threshold: [0]
        }
      );

      this.stickyObserver.observe(this.$refs.stickySentinel);
      this.updateTitleStickyState();
    },
    initScrollFallback() {
      this.onScroll = () => {
        if (this.stickyScrollAnimationFrame) {
          return;
        }

        if (!window.requestAnimationFrame) {
          this.updateTitleStickyState();
          return;
        }

        this.stickyScrollAnimationFrame = window.requestAnimationFrame(() => {
          this.stickyScrollAnimationFrame = null;
          this.updateTitleStickyState();
        });
      };

      window.addEventListener('scroll', this.onScroll, { passive: true });
    },
    onWatchToggle() {
      this.retrieveMarketData({ marketId: this.marketId, clearOrderBook: false, clearMarket: true, loader: false });
    },
    onTitleMouseOver() {
      this.titleHovered = true;
    },
    onTitleMouseLeave() {
      this.titleHovered = false;
    },
    openNewMarketStats() {
      this.loaderAdd(document.body);
      this.getMarketContractsStats(this.market.marketId)
        .then((data) => {
          this.loaderRemove(document.body);
          if (!data) {
            return;
          }
          this.setGenericPopup({
            name: MODALS.MARKET_CONTRACT_STATS,
            options: {
              stats: data,
              isFixed: hasMarketHiddenContracts(this.market),
            },
          });
        })
        .catch(() => this.loaderRemove(document.body));
    },
    openPotentialPayouts() {
      this.setGenericPopup({
        name: MODALS.POTENTIAL_PAYOUTS,
        options: {
          market: this.market,
        },
      });
    },
    syncDiscussionLocation(commentId = '', commentThreadId = 0) {
      const currentQuery = getCurrentLocationQuery();
      const resolvedRoute = this.$router.resolve({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          dontReload: true,
        },
        query: buildDiscussionQuery(currentQuery, commentId, commentThreadId),
        hash: buildCommentHash(commentId),
      });

      // Keep Disqus-only state out of Vue Router so the routed page shell does not remount.
      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
    },
    syncTabLocation(tab) {
      const currentQuery = getCurrentLocationQuery();
      const resolvedRoute = this.$router.resolve({
        name: this.$route.name,
        params: {
          ...this.$route.params,
          dontReload: true,
        },
        query: buildTabQuery(currentQuery, tab),
        hash: '',
      });

      window.history.replaceState(window.history.state, document.title, resolvedRoute.href);
    },
    resolveActiveTabForCurrentUser(tab) {
      if (!ROUTE_DRIVEN_TABS.includes(tab)) {
        return NAVIGATION_TABS.CONTRACTS;
      }

      if (AUTH_REQUIRING_TABS.includes(tab) && !this.isLoggedIn) {
        return NAVIGATION_TABS.CONTRACTS;
      }

      return tab;
    },
    syncActiveTabFromRoute() {
      const currentQuery = getCurrentLocationQuery();
      const activeTab = this.resolveActiveTabForCurrentUser(this.$route.query.tab || currentQuery.tab);

      if (activeTab !== this.activeTab) {
        this.activeTab = activeTab;
      }

      this.scheduleToolbarTabIntoView(activeTab);
    },
    updateDiscussionRequest({ commentId = '', commentThreadId = 0 } = {}) {
      this.requestedDiscussionCommentId = commentId;
      this.requestedDiscussionCommentThreadId = normalizeCommentThreadId(commentThreadId);
      this.syncDiscussionLocation(this.requestedDiscussionCommentId, this.requestedDiscussionCommentThreadId);
    },
    onOpenDiscussion() {
      this.activeTab = NAVIGATION_TABS.DISCUSSION;
      this.updateDiscussionRequest();
    },
    onOpenDiscussionComment(comment) {
      const commentId = comment && comment.commentId ? comment.commentId : '';
      const commentThreadId = comment && comment.commentThreadId ? Number(comment.commentThreadId) : 0;

      this.activeTab = NAVIGATION_TABS.DISCUSSION;
      this.updateDiscussionRequest({
        commentId,
        commentThreadId,
      });
    },
    onDiscussionRequestChange(payload = {}) {
      this.updateDiscussionRequest(payload);
    },
    navigationTabChange(name) {
      log.info(`[TABS] Change to: ${name} from ${this.activeTab}`)
      const isTheSameTab = this.activeTab === name;

      if (isTheSameTab) {
        return;
      }

      if (this.activeTab === NAVIGATION_TABS.DISCUSSION) {
        this.discussionWidgetRouteSwap += 1;
      }

      // Only do the desktop reset when the tabs are already pinned, otherwise we bring the old toolbar jump back in the non-sticky state.
      const shouldResetDesktopTabContentScroll = this.isLayoutDesktop && this.isDesktopToolbarPinned();
      const shouldPreserveMobileToolbarPosition = this.isLayoutMobile && this.isMobileToolbarVisible();

      if (this.isLayoutDesktop) {
        this.captureDesktopContentHeight();
      } else {
        // Mobile needs the outgoing panel height held through the swap so the page does not
        // shrink and yank the midpage tabs around before the new panel finishes mounting.
        this.captureMobileContentHeight();
        this.tabScrollPositions[this.activeTab] = window.scrollY || window.pageYOffset;
      }

      this.activeTab = name;
      if (this.activeTab === NAVIGATION_TABS.DISCUSSION) {
        this.updateDiscussionRequest();
      } else {
        this.requestedDiscussionCommentId = '';
        this.requestedDiscussionCommentThreadId = 0;
        this.syncTabLocation(this.activeTab);
      }
      if (this.activeTab === NAVIGATION_TABS.CONTRACTS) {
        this.setBottomWidgetFooterMode(this.bottomWidgetFooterModeContractsSection)
      }
      this.$nextTick(() => {
        this.scheduleToolbarTabIntoView(name);

        if (this.isLayoutDesktop) {
          this.refreshDesktopContentHeightTracking();

          if (shouldResetDesktopTabContentScroll) {
            if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
              window.requestAnimationFrame(() => {
                this.resetDesktopTabContentScroll();
              });
            } else {
              this.resetDesktopTabContentScroll();
            }
          }
          return;
        }

        this.restoreMobileTabContentScroll(name, { preserveToolbarPosition: shouldPreserveMobileToolbarPosition });
      });
    },
    retrieveMarketData({ marketId, clearMarket = true, clearOrderBook = true, loader = true }) {
      if (clearOrderBook) {
        this.clearOrderBook();
      }
      if (marketId) {
        if (loader) {
          this.loaderAdd(document.body);
        }
        const commentThreadId = this.$route.query.commentThreadId;
        return this.getMarket({ marketId, commentThreadId, skipCache: clearMarket })
          .then((data) => {
            if (loader) {
              this.loaderRemove(document.body);
            }
            if (data.econIndicatorTradeStatus === 3) {
              this.setCurrentPopup(MODALS.AFFILIATIONS);
            }
          }).catch(() => {
            if (loader) {
              this.loaderRemove(document.body);
            }
            this.$router.push({ name: 'not-found' });
        })
      }
      return Promise.resolve(1);
    },
    addBoxLoading() {
      const $el = document.querySelector('.purchase-offer-desktop-sushi-common-betslip__box');
      if ($el) {
        $el.classList.add('purchase-offer-desktop-sushi-common-betslip__box--loading');
      }

      const $el2 = document.querySelector('.purchase-offer-sushi-mobile-bar');
      if ($el2) {
        $el2.classList.add('purchase-offer-sushi-mobile-bar--loading');
      }
    },
    removeBoxLoading() {
      const $el = document.querySelector('.purchase-offer-desktop-sushi-common-betslip__box');
      if ($el) {
        $el.classList.remove('purchase-offer-desktop-sushi-common-betslip__box--loading');
      }

      const $el2 = document.querySelector('.purchase-offer-sushi-mobile-bar');
      if ($el2) {
        $el2.classList.remove('purchase-offer-sushi-mobile-bar--loading');
      }
    },
    loadHandler(value) {
      if (!this.initialised) {
        this.applyDefaultMobileFooterMode();
        this.startPageSetup();
      }

      this.addBoxLoading();
      this.reloading = true;

      if (value) {
        this.retrieveMarketData({
          marketId: this.marketId, clearOrderBook: false, clearMarket: true,
        })
          .then(waitForStatusReady)
          .then(() => {
            if (!this.initialised) {
              this.setupPage();
            } else {
              this.switchContractSideIfNecessaryBecauseOfOwnership();
            }
            this.syncActiveTabFromRoute();
            this.removeBoxLoading();
            this.initialised = true;
            this.reloading = false;
          });
      } else {
        this.retrieveMarketData({
          marketId: this.marketId, clearOrderBook: true, clearMarket: true,
        })
          .then(() => {
            if (!this.initialised) {
              this.setupPage();
            }
            this.syncActiveTabFromRoute();
            this.removeBoxLoading();
            this.initialised = true;
            this.reloading = false;
          });
      }
    },
    switchContractSideIfNecessaryBecauseOfOwnership() {
      if (this.isMarketDisabled) {
        return;
      }

      if (!this.tradeOptions.contractId) {
        return;
      }

      const contract = this.contracts.find(c => c.contractId === this.tradeOptions.contractId);
      if (!contract) {
        return;
      }

      const contractModel = new Contract(contract);
      if (!contractModel.mode || contractModel.mode === this.tradeOptions.operationValue) {
        return;
      }
      log.info('[PURCHASE] switching sides after signin');
      this.setTradeOptions({
        contractId: contract.contractId,
        operationType: OPERATIONS.BUY,
        operationValue: contractModel.mode
      })
      this.setTradePrice(contractModel.mode === VALUES.YES ? contractModel.buyYesCostAsCents : contractModel.buyNoCostAsCents);
    },
    startPageSetup() {
      this.isResetting = true
      this.isTitleSticky = false;
      this.hideMainChart = false;
      this.destroyStickyTracking();
      this.destroyDesktopContentHeightTracking({ resetHeight: true });
      this.destroyMobileContentHeightLock({ resetHeight: true });
    },
    setupPage() {
      this.isResetting = false
      this.reorganizeTags();
      this.refreshStickyObserver();
      this.refreshDesktopContentHeightTracking();
      this.initToolbarTabsScrollTracking();
    },
  },
  watch: {
    lastConfirmedContractData(data) {
      const contractIds = (this.contracts || []).map(i => i.contractId);
      if (data && data.matched && contractIds.includes(data.id)) {
        this.showHistory = true;
      }
    },
    isLoggedIn: {
      handler: 'loadHandler',
      immediate: true,
    },
    headerHeight(value, oldValue) {
      if (!value || value === oldValue) {
        return;
      }

      this.syncDesktopStickyTitleHeight();
      this.refreshStickyObserver();
    },
    isLayoutMobile(value, oldValue) {
      if (value === oldValue) {
        return;
      }

      this.destroyMobileContentHeightLock({ resetHeight: true });
      this.initToolbarTabsScrollTracking();

      if (value) {
        this.destroyDesktopContentHeightTracking({ resetHeight: true });
      } else {
        this.refreshDesktopContentHeightTracking();
      }

      this.syncDesktopStickyTitleHeight();
      this.refreshStickyObserver();
    },
    bottomBetslipExtended(value, oldValue) {
      if (value === oldValue || !this.isLayoutMobile) {
        return;
      }

      this.scheduleStickyTitleStateUpdate();
    },
    isTitleSticky(value, oldValue) {
      if (value === oldValue) {
        return;
      }

      this.$nextTick(() => {
        this.syncDesktopStickyTitleHeight();

        if (value && typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(() => {
            this.syncDesktopStickyTitleHeight();
          });
        }
      });
    },
    showStickyTitleSummary(value, oldValue) {
      if (value === oldValue) {
        return;
      }

      this.$nextTick(() => {
        this.syncDesktopStickyTitleHeight();

        if (this.isLayoutDesktop && typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
          window.requestAnimationFrame(() => {
            this.syncDesktopStickyTitleHeight();
          });
        }
      });
    },
    $route(to, from) {
      if (from && to) {
        this.activeTab = this.resolveActiveTabForCurrentUser(to.query.tab)
        this.requestedDiscussionCommentId = resolveDiscussionCommentId(to);
        this.requestedDiscussionCommentThreadId = normalizeCommentThreadId(to.query.commentThreadId);
        this.scheduleToolbarTabIntoView(this.activeTab);

        if (resolveRouteMarketId(to) === resolveRouteMarketId(from)) {
          return;
        }

        this.applyDefaultMobileFooterMode({ fromRoute: from });
        this.setBottomBetSlipExtendedMode(false);
        this.startPageSetup()
        this.retrieveMarketData({
          marketId: to.params.marketId,
          clearOrderBook: true,
          clearMarket: true,
        }).then(() => {
          this.setupPage();
        })
      }
    },
  },
  beforeDestroy() {
    this.destroyStickyTracking();
    this.destroyDesktopContentHeightTracking({ resetHeight: true });
    this.destroyMobileContentHeightLock({ resetHeight: true });
    this.destroyToolbarTabsScrollTracking();
    this.clearMarketEngineBusyMessage();
    this.setTradeOptions(null);
    this.toggleHidePurchaseForContractId(null);
    this.clearMarket();
    this.clearOrderBook();
    this.setBottomBetSlipExtendedMode(false);
    document.title = DEFAULT_PAGE_TITLE;
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-market-detail-sushi/page-market-detail-sushi.js